import { formatAmount, parseDbTimestamp } from "@repo/shared";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { usePayments } from "@/lib/hooks/use-billing";
import { useT } from "@/lib/i18n/use-t";
import { useRegionalFormat } from "@/lib/regional-format/context";
import { T } from "./page.i18n";

export default function BillingInvoicesPage() {
  const { formatDate } = useRegionalFormat();
  const t = useT(T);
  const { data: payments, isLoading } = usePayments();

  if (isLoading) {
    return (
      <div className="space-y-4">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-64 w-full" />
      </div>
    );
  }

  if (!payments || payments.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>{t.paymentHistory}</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">{t.noPayments}</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t.paymentHistory}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="pb-2 text-left font-medium">{t.date}</th>
                <th className="pb-2 text-left font-medium">{t.amount}</th>
                <th className="pb-2 text-left font-medium">{t.status}</th>
              </tr>
            </thead>
            <tbody>
              {payments.map((payment) => (
                <tr key={payment.id} className="border-b last:border-0">
                  <td className="py-2">{formatDate(parseDbTimestamp(payment.createdAt))}</td>
                  <td className="py-2">{formatAmount(payment.amount, payment.currency)}</td>
                  <td className="py-2">
                    <Badge
                      variant={
                        payment.status === "paid"
                          ? "default"
                          : payment.status === "failed"
                            ? "destructive"
                            : "secondary"
                      }
                    >
                      {payment.status === "paid"
                        ? t.paid
                        : payment.status === "failed"
                          ? t.failed
                          : payment.status === "refunded"
                            ? t.refunded
                            : payment.status}
                    </Badge>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
}
